import { OperatorUnion, Operator } from '@procureai/query-builder';
import { ValueEditorSelect, ValueEditorSelectProps } from '@procureai/query-builder-ui-mui';
import { useTranslation } from 'react-i18next';

import { SupplierRelationshipType } from '@/generated/gql/graphql';

interface ValueEditorSelectRelationshipProps extends ValueEditorSelectProps {
  operator: OperatorUnion;
}

export const ValueEditorSelectRelationship = ({ operator, ...otherProps }: ValueEditorSelectRelationshipProps) => {
  const { t } = useTranslation();

  return (
    <ValueEditorSelect
      {...otherProps}
      options={[SupplierRelationshipType.known, SupplierRelationshipType.unknown, SupplierRelationshipType.partner]}
      getOptionLabel={(option) => t(`QueryBuilder.relationship.${option}`)}
      multiple={operator === Operator.IN}
    />
  );
};
